//import bowser from 'bowser';
//const browser = bowser.parse(window.navigator.userAgent);

export default {
    isDateCompatible: () => {
        return true;
    }
}
